<template>
  <div class="main" v-if="false">
    <div class="container">
      <div class="search">
        <el-button size="mini" type="primary" @click="openBindStore">绑定店铺</el-button>
        <div>
          <div class="demo-input-suffix">
            店铺名:
            <el-input
              class="searchInput searchInput2"
              size="mini"
              v-model="store"
              placeholder="请输入店铺名"
              @change="clickEnter"
            ></el-input>
          </div>
          <div class="demo-input-suffix">
            状态:
            <el-select
              v-model="statusSingle"
              placeholder="请选择"
              size="mini"
              @change="statusChange(statusSingle)"
            >
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <el-button size="mini" type="primary" @click="()=>this.getShop()">查询</el-button>
          <!-- 绑定店铺 -->
          <el-dialog
            title="添加Shopify授权"
            :visible.sync="dialogFormVisible"
            width="650px"
            :close-on-click-modal="false"
          >
            <el-form :model="form">
              <el-form-item label="店铺地址:" label-width="120px">
                <el-input placeholder="请输入" v-model="name" size="small">
                  <template slot="prepend">https://</template>
                  <template slot="append">.myshopify.com</template>
                </el-input>
              </el-form-item>
              <el-form-item label="AppName:" label-width="120px">
                <el-input placeholder="请输入AppName" v-model="appname" size="small"></el-input>
              </el-form-item>
              <el-form-item label="Client Id:" label-width="120px">
                <el-input placeholder="请输入ClientId" v-model="clientid" size="small"></el-input>
              </el-form-item>
              <el-form-item label="Secret:" label-width="120px">
                <el-input placeholder="请输入Secret" v-model="secret" size="small"></el-input>
              </el-form-item>
              <el-form-item label="收款账号:" label-width="120px">
                <el-select
                  v-model="paypalid"
                  placeholder="请选择收款账号"
                  size="small"
                  class="selectInput"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button size="small" type="primary" @click="Authorization">确 定</el-button>
              <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
      <div class="BigContent" v-if="storeResult.page.length">
        <div class="itemNav">
          <span>
            <el-checkbox v-model="allChecked" @change="allChenkedChange"></el-checkbox>
          </span>
          <span>序号</span>
          <span>店铺名</span>
          <span>店铺地址</span>
          <span>收款</span>
          <span>店铺状态</span>
          <span>授权时间</span>
          <span>操作</span>
        </div>
        <div
          class="item"
          v-for="(item,index) in storeResult.page"
          :key="item.id"
          @click="editStore(item.id)"
        >
          <span @click.stop>
            <el-checkbox v-model="item.isFlag" @change="(e)=>singleChecked(e,item.id)"></el-checkbox>
          </span>
          <span>{{ index+1 }}</span>
          <span>{{ item.name }}</span>
          <span>
            <a :href="item.url" target="blank">{{ item.url }}</a>
          </span>
          <span>{{ item.payname }}</span>
          <span @click.stop>
            <el-switch
              v-model="item.status"
              active-color="#00A854"
              :active-value="1"
              inactive-color="#F04134"
              :inactive-value="0"
              @change="(val)=>switchChange(val,item.id)"
            ></el-switch>
          </span>
          <span>{{ item.time }}</span>
          <span>
            <!-- <span>修改</span>
            <span>|</span>-->
            <span @click.stop="romoveStore(item.id)">删除</span>
          </span>
        </div>

        <!-- 修改店铺 -->
        <el-dialog
          title="修改Shopify授权"
          :visible.sync="dialogFormVisible2"
          width="650px"
          :close-on-click-modal="false"
        >
          <el-form :model="form">
            <el-form-item label="AppName:" label-width="120px">
              <el-input placeholder="请输入AppName" v-model="appname" size="small"></el-input>
            </el-form-item>
            <el-form-item label="Client Id:" label-width="120px">
              <el-input placeholder="请输入ClientId" v-model="clientid" size="small"></el-input>
            </el-form-item>
            <el-form-item label="Secret:" label-width="120px">
              <el-input placeholder="请输入Secret" v-model="secret" size="small"></el-input>
            </el-form-item>
            <el-form-item label="收款账号:" label-width="120px">
              <el-select v-model="paypalid" placeholder="请选择收款账号" size="small" class="selectInput">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="confirmEditStore">确 定</el-button>
            <el-button size="small" @click="dialogFormVisible2 = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 分页 -->
        <div class="pag">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[20, 50, 100, 200]"
            :page-size="size"
            :total="storeResult.total"
            :page-count="storeResult.pnum"
            @current-change="pageChange"
            @size-change="sizeChange"
          ></el-pagination>
        </div>
      </div>
      <div class="emptyData" v-else>暂无数据</div>
    </div>
  </div>
  <div v-else>原页面已转至shopify专营模块下</div>
</template>

<script>
import isFlag from "../../components/isFlag";
import {
  getAuthorization,
  getShopData,
  optshop,
  getStoreDetail,
  getStoreDrop
} from "../../service";
export default {
  data() {
    return {
      input: "",
      allChecked: false,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      pageNum: 1, //分页的当前页数，
      size: 20, //每页显示条数，默认显示20条每页
      name: "",
      form: {
        name: ""
      },
      store: "",
      storeResult: { page: [] },
      appname: "",
      clientid: "",
      secret: "",
      paypalid: "", //收款账号
      statusList: [
        //状态筛选项列表
        {
          value: 2,
          label: "全部"
        },
        {
          value: 1,
          label: "已启用"
        },
        {
          value: 0,
          label: "已禁用"
        }
      ],
      statusSingle: "", //状态
      options: [],
      storeid: null //店铺id
    };
  },
  created() {
    this.getShop();
    this.getStoreDropData();
  },
  methods: {
    //绑定店铺 获取授权
    Authorization() {
      if (
        this.name === "" ||
        this.appname === "" ||
        this.clientid === "" ||
        this.secret === "" ||
        this.paypalid === ""
      ) {
        this.$message({
          message: "所填项不能为空！",
          type: "warning"
        });
      } else {
        this.dialogFormVisible = false;
        let params = {
          name: this.name,
          appname: this.appname,
          clientid: this.clientid,
          secret: this.secret,
          paypalid: this.paypalid
        };
        getAuthorization(params).then(res => {
          if (res.data.code === 0) {
            window.open(res.data.result.url, "_self");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    // 获取店铺列表
    getShop(p = 1) {
      let params = {
        p,
        name: this.store,
        status: this.statusSingle,
        size: this.size
      };
      if (params.status === 2) {
        params.status = "";
      }
      getShopData(params).then(res => {
        if (res.data.code === 0) {
          this.storeResult = res.data.result;
          this.storeResult.page.map((item, i) => {
            item.isFlag = false;
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 店铺状态发生改变
    switchChange(val, id) {
      let params = { id: id, opt: val };
      optshop(params).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: "店铺状态修改成功",
            type: "success",
            duration: 1000,
            onClose: () => {
              this.getShop(this.pageNum);
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 打开修改店铺
    editStore(id) {
      let params = { id };
      this.storeid = id;
      getStoreDetail(params).then(res => {
        this.dialogFormVisible2 = true;
        if (res.data.code === 0) {
          this.name = res.data.result.name;
          this.appname = res.data.result.appname;
          this.clientid = res.data.result.clientid;
          this.secret = res.data.result.secret;
          this.paypalid = res.data.result.paypalid;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 确定修改店铺
    confirmEditStore() {
      let params = {
        id: this.storeid,
        opt: 3,
        appname: this.appname,
        clientid: this.clientid,
        secret: this.secret,
        paypalid: this.paypalid
      };
      optshop(params).then(res => {
        this.dialogFormVisible2 = false;
        if (res.data.code === 0) {
          this.$message({
            message: "店铺修改成功",
            type: "success",
            duration: 1000,
            onClose: () => {
              this.getShop(this.pageNum);
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 下拉选收款账号
    getStoreDropData() {
      getStoreDrop().then(res => {
        if (res.data.code === 0) {
          this.options = res.data.result;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 打开绑定店铺
    openBindStore() {
      this.dialogFormVisible = true;
      this.name = "";
      this.appname = "";
      this.clientid = "";
      this.secret = "";
      this.paypalid = "";
    },
    // 状态选中发生改变
    statusChange(val) {
      this.getShop();
    },
    // 分页
    pageChange(activePage) {
      this.allChecked = false;
      this.pageNum = activePage;
      this.getShop(activePage);
    },
    // 分页的每页条数发生改变
    sizeChange(val) {
      this.size = val;
      this.getShop();
    },
    // 点击改变单选
    singleChecked(e, id) {
      let arr = JSON.parse(JSON.stringify(this.storeResult.page));
      arr.map((item, i) => {
        if (item.orderno === id) {
          this.$set(item, "isFlag", e);
        }
      });
      this.storeResult.page = JSON.parse(JSON.stringify(arr));
      this.isAllChecked();
    },
    // 单选改变全选
    isAllChecked() {
      let flag = true;
      this.storeResult.page.map((item, i) => {
        if (item.isFlag === false) {
          flag = false;
        }
      });
      this.allChecked = flag;
    },
    // 全选改变单选
    allChenkedChange(e) {
      let arr = JSON.parse(JSON.stringify(this.storeResult.page));
      arr.map((item, i) => {
        arr[i].isFlag = e;
      });
      this.storeResult.page = JSON.parse(JSON.stringify(arr));
    },
    // 删除店铺
    romoveStore(id) {
      this.$confirm("确定删除吗?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = { id, opt: 2 };
          optshop(params).then(res => {
            if (res.data.code === 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
                duration: 1000,
                onClose: () => {
                  this.getShop(this.pageNum);
                }
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 点击回车触发查询
    clickEnter() {
      this.getShop();
    }
  },
  components: {
    isFlag
  }
};
</script>

<style lang="less" scoped>
.main {
  background-color: #fff;
  border: 1px solid rgba(235, 237, 248, 1);
}
.container {
  width: 100%;
  padding: 0 20px;
  padding-top: 20px;
  border: none;
  box-sizing: border-box;
  .search {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    > div {
      display: flex;
      > div {
        margin-right: 4px;
      }
    }
    > div:last-child {
      margin-right: 0px;
    }
    .searchInput {
      width: 200px;
      border-radius: 0px;
      /deep/ .el-input__inner {
        border-radius: 4px;
      }
    }
    .searchBtn {
      height: 40px;
      background: rgba(0, 119, 255, 1);
      border-radius: 0px 3px 3px 0px;
    }
  }
  .total {
    margin: 10px 0;
  }
  .itemNav,
  .item {
    padding-left: 18px;
    &:hover {
      background-color: #eee;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 16px;
    }
    span:nth-child(1) {
      width: 30px;
      display: inline-block;
      margin-right: 0;
    }
    span:nth-child(2) {
      display: inline-block;
      text-align: center;
      width: 6%;
    }
    span:nth-child(3) {
      display: inline-block;
      text-align: center;
      width: 14%;
    }
    span:nth-child(4) {
      display: inline-block;
      text-align: center;
      width: 26%;
      > a {
        color: #1980ff;
        &:hover {
          cursor: pointer;
        }
      }
    }
    span:nth-child(5) {
      display: inline-block;
      text-align: center;
      width: 14%;
    }
    span:nth-child(6) {
      display: inline-block;
      text-align: center;
      width: 10%;
    }
    span:nth-child(7) {
      display: inline-block;
      text-align: center;
      width: 12%;
    }
    span:nth-child(8) {
      display: inline-block;
      text-align: center;
      width: 14%;
    }
  }
  .itemNav {
    margin-bottom: 10px;
    &:hover {
      background-color: #fff;
    }
  }
  .item {
    background: rgba(246, 249, 252, 1);
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    height: 48px;
    &:hover {
      cursor: pointer;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    span:nth-child(8) {
      color: #1980ff;
      > span {
        display: inline;
        color: #1980ff;
        &:hover {
          cursor: pointer;
        }
      }
      > span:nth-child(2),
      > span:nth-child(4) {
        margin: 0 4px;
        color: #e6e6e6;
        &:hover {
          cursor: auto;
        }
      }
      /deep/ .el-dropdown {
        width: 30px;
        span {
          color: #1980ff;
        }
      }
      > .more {
        display: inline;
      }
    }
  }
  .pag {
    margin: 22px 0;
    text-align: center;
    /deep/ .btn-prev,
    /deep/ .btn-next {
      padding: 0 8px;
    }
  }
}
.isFlag {
  width: 59px;
  height: 24px;
  background: rgba(223, 227, 232, 1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  padding: 0 13px;
  font-size: 12px;
  > span:first-child {
    width: 0 !important;
    box-sizing: border-box;
    border: 6px solid #999;
    display: inline-block;
    border-radius: 50%;
  }
  > p {
    display: inline-block;
    height: 14px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 14px;
    margin-left: 10px;
  }
}
.dialog-footer {
  text-align: center;
}
.emptyData {
  text-align: center;
  width: 100%;
  line-height: 200px;
  font-size: 20px;
  color: #e6e6e6;
}
/deep/ .el-select {
  width: 100px !important;
}
.selectInput {
  width: 100% !important;
}
.el-form-item {
  margin-bottom: 0px;
}
</style>